module.exports = __webpack_public_path__ + "static/media/madalina_radu.4f5009b0.jpg";